import ConfigurationEdit from '@/components/pages/core/security/ConfigurationEdit'
import Configuration from '@/components/pages/core/security/Configuration'
import RunAs from '@/components/pages/core/security/RunAs'
import RecoverPassword from '@/components/pages/core/security/RecoverPassword'
import SetPassword from '@/components/pages/core/security/SetPassword'
import Users from '@/components/pages/core/management/user/Users'
import User from '@/components/pages/core/management/user/User'
import UserEdit from '@/components/pages/core/management/user/UserEdit'
import Groups from '@/components/pages/core/management/group/Groups'
import Group from '@/components/pages/core/management/group/Group'
import GroupEdit from '@/components/pages/core/management/group/GroupEdit'
import CreateOrganization from '@/components/pages/core/management/organization/CreateOrganization'
import ViewOrganization from '@/components/pages/core/management/organization/ViewOrganization'
import UserPreferences from '@/components/pages/core/security/UserPreference'
import AuditTrail from '@/components/pages/core/management/AuditTrail'

export default [
  {
    path: '/core/security/userpreferences',
    component: UserPreferences,
    name: 'userPreferences',
    meta: {
      title: 'User Preferences',
      icon: 'fa fa-user-o'
    }
  },
  {
    path: '/core/management/audittrail',
    component: AuditTrail,
    name: 'auditTrail',
    meta: {
      title: 'Audit Trail',
      icon: 'fa fa-ellipsis-h'
    }
  },
  {
    path: '/core/management/group/new/group',
    component: GroupEdit,
    name: 'groupNew',
    meta: {
      title: 'New Group',
      icon: 'fa fa-users',
      breadcrumb: [
        { path: '#/core/management/groups', title: 'Groups' },
      ]
    }
  },
  {
    path: '/core/management/group/:id/edit',
    component: GroupEdit,
    name: 'groupEdit',
    meta: {
      title: 'Edit Group - {{ params.id}}',
      icon: 'fa fa-users',
      breadcrumb: [
        { path: '#/core/management/groups', title: 'Groups' },
        { path: '#/core/management/group/{{ params.id}}', title: 'Group {{ params.id}}' }
      ]
    }
  },
  {
    path: '/core/management/group/:id',
    component: Group,
    name: 'group',
    meta: {
      title: 'Group - {{ params.id}}',
      icon: 'fa fa-users',
      breadcrumb: [
        { path: '#/core/management/groups', title: 'Groups' },
      ]
    }
  },
  {
    path: '/core/management/groups',
    component: Groups,
    name: 'groups',
    meta: {
      title: 'Groups',
      icon: 'fa fa-users'
    }
  },
  {
    path: '/core/management/users',
    component: Users,
    name: 'users',
    meta: {
      title: 'Users',
      icon: 'fa fa-user-circle-o'
    }
  },
  {
    path: '/core/management/user/:id',
    component: User,
    name: 'user',
    meta: {
      title: 'User - {{ params.id}}',
      icon: 'fa fa-user-circle-o',
      breadcrumb: [
        { path: '#/core/management/users', title: 'Users' }
      ]
    }
  },
  {
    path: '/core/management/user/new/user',
    component: UserEdit,
    name: 'userNew',
    meta: {
      title: 'New User',
      icon: 'fa fa-user-circle-o',
      breadcrumb: [
        { path: '#/core/management/users', title: 'Users' },
      ]
    }
  },
  {
    path: '/core/management/user/:id/edit',
    component: UserEdit,
    name: 'userEdit',
    meta: {
      title: 'Edit User {{ params.id}}',
      icon: 'fa fa-user-circle-o',
      breadcrumb: [
        { path: '#/core/management/users', title: 'Users' },
        { path: '#/core/management/user/{{ params.id}}', title: 'User {{ params.id}}' }
      ]
    }
  },
  {
    path: '/core/configuration/organization/edit',
    component: ConfigurationEdit,
    name: 'configurationEdit',
    meta: {
      title: 'Edit Configuration',
      breadcrumb: [
        { path: '#/core/configuration/organization', title: 'Configuration' },
        { title: 'Edit configuration' }
      ]
    }
  },
  {
    path: '/core/configuration/organization',
    component: Configuration,
    name: 'configuration',
    meta: {
      title: 'Configuration'
    }
  },
  {
    path: '/security/recoverpassword',
    component: RecoverPassword,
    name: 'recoverPassword',
    meta: {
      authNotRequired: true
    }
  },
  {
    path: '/security/setpassword',
    component: SetPassword,
    name: 'setPassword',
    meta: {
      authNotRequired: true
    }
  },
  {
    path: '/security/run-as',
    component: RunAs,
    name: 'runAs',
    meta: {
      title: 'Run as'
    }
  },
  {
    path: '/core/management/organization',
    component: ViewOrganization,
    name: 'viewOrganization',
    meta: {
      title: 'Organization',
      icon: 'fa fa-sitemap',
    }
  },
  {
    path: '/core/management/organization/new',
    component: CreateOrganization,
    name: 'createOrganization',
    meta: {
      title: 'Create Organization',
      icon: 'fa fa-sitemap',
    }
  },
]



// WEBPACK FOOTER //
// ./src/router/routes/security.js